// extracted by mini-css-extract-plugin
export default {"scrollableTabshello":"ScrollAbleTabs_scrollableTabshello__JkfP8","tabWrapper":"ScrollAbleTabs_tabWrapper__nqS2A","scrollTabsBar":"ScrollAbleTabs_scrollTabsBar__P-f2B"};